import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  loaderContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "80vh",
  },
  loader: { color: "black" },
}));

export default function Loader() {
  const classes = useStyles();
  return (
    <div className={classes.loaderContainer}>
      <CircularProgress className={classes.loader} size={90} />
    </div>
  );
}
